//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from './component/LandMapNq/js/bus';
import LandMap from "./component/LandMapNq";
import Searchs from "./component/searchs";

export default {
  components: {LandMap,Searchs},
  props: [],
  data() {
    return {
      SearchName:'',
      MasterId:''
    };
  },
  mounted() {},
  created() {},
  methods: {
    changeSearchName(e){
      this.SearchName = e
    },
    changeMasterId(e){
      this.MasterId = e
    },
  },
};
